import React from 'react';

import PropTypes from 'prop-types';
import { css } from 'styled-components';

import {
  desktop,
  FilterTags as BaseFilterTags,
} from '~/techstyle-shared/react-components';

const headerStyle = css`
  font-size: 16px;
  font-weight: normal;

  ${({ theme }) => theme.gridFilterStyles.headerStyle}
`;

const tagListStyle = css`
  margin: 16px auto;

  > li {
    font-size: 12px;
    line-height: 16px;
    padding: 4px 8px;

    ${({ theme }) => theme.gridFilterStyles.tagStyle}

    button {
      padding: unset;
      height: unset;
      font-size: 14px;
      vertical-align: -1px;
      line-height: 12px;
      margin-left: 8px;

      svg {
        stroke-width: 2px;
        font-size: 11px;
        vertical-align: 0;
        ${({ theme }) => theme.gridFilterStyles.deselectIconStyle}
      }
    }
  }
`;

const clearAllButtonStyle = css`
  text-decoration: underline;

  &&& {
    font-size: 14px;
    line-height: 18px;

    ${({ theme }) => theme.gridFilterStyles.clearAllButtonStyle}
  }
  height: fit-content;
  ${desktop`
	  padding: 4px 0 0 0;
	`}
`;

const FilterTags = React.forwardRef(
  ({ as: ElementType = BaseFilterTags, ...rest }, ref) => (
    <ElementType
      ref={ref}
      headerStyle={headerStyle}
      tagListStyle={tagListStyle}
      clearAllButtonStyle={clearAllButtonStyle}
      {...rest}
    />
  )
);

FilterTags.displayName = 'FilterTags';

FilterTags.propTypes = {
  as: PropTypes.elementType,
};
export default FilterTags;
